import { SvgIcon } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';
import React from 'react';

interface PlannerIconProps {
  isSelected?: boolean;
  isHover?: boolean;
  style?: React.CSSProperties;
}

export default function PlannerIcon({ isSelected = false, isHover = false, style = {}, ...props }: PlannerIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24" style={{ width: `28px`, height: `28px`, ...style }}>
      <g>
        {isSelected ? (
          <>
            <path
              fill={RoutalPalette.primary40}
              d="m18.16,2.11v2.41c0,.83-.67,1.5-1.5,1.5s-1.5-.67-1.5-1.5v-2.44h-6.31v2.44c0,.83-.67,1.5-1.5,1.5s-1.5-.67-1.5-1.5v-2.41C2.95,2.39.69,4.83.69,7.79v10.1c0,3.15,2.56,5.72,5.72,5.72h11.19c3.15,0,5.72-2.56,5.72-5.72V7.79c0-2.96-2.27-5.41-5.16-5.69Z"
            />
            <path
              fill={RoutalPalette.primary40}
              d="m7.34,5.27c-.41,0-.75-.34-.75-.75V1.14c0-.41.34-.75.75-.75s.75.34.75.75v3.38c0,.41-.34.75-.75.75Z"
            />
            <path
              fill={RoutalPalette.primary40}
              d="m16.66,5.27c-.41,0-.75-.34-.75-.75V1.14c0-.41.34-.75.75-.75s.75.34.75.75v3.38c0,.41-.34.75-.75.75Z"
            />
            <circle fill={RoutalPalette.neutral00} cx="6.19" cy="10.18" r="2.05" />
            <circle fill={RoutalPalette.neutral00} cx="17.81" cy="10.18" r="2.05" />
            <circle fill={RoutalPalette.neutral00} cx="12" cy="17.02" r="2.05" />
            <circle fill={RoutalPalette.neutral00} cx="17.81" cy="17.02" r="2.05" />
          </>
        ) : isHover ? (
          <>
            <path
              fill={RoutalPalette.primary20}
              d="m18.16,2.11v2.41c0,.83-.67,1.5-1.5,1.5s-1.5-.67-1.5-1.5v-2.44h-6.31v2.44c0,.83-.67,1.5-1.5,1.5s-1.5-.67-1.5-1.5v-2.41C2.95,2.39.69,4.83.69,7.79v10.1c0,3.15,2.56,5.72,5.72,5.72h11.19c3.15,0,5.72-2.56,5.72-5.72V7.79c0-2.96-2.27-5.41-5.16-5.69Z"
            />
            <path
              fill={RoutalPalette.primary20}
              d="m7.34,5.27c-.41,0-.75-.34-.75-.75V1.14c0-.41.34-.75.75-.75s.75.34.75.75v3.38c0,.41-.34.75-.75.75Z"
            />
            <path
              fill={RoutalPalette.primary20}
              d="m16.66,5.27c-.41,0-.75-.34-.75-.75V1.14c0-.41.34-.75.75-.75s.75.34.75.75v3.38c0,.41-.34.75-.75.75Z"
            />
            <circle fill={RoutalPalette.neutral00} cx="6.19" cy="10.18" r="2.05" />
            <circle fill={RoutalPalette.neutral00} cx="17.81" cy="10.18" r="2.05" />
            <circle fill={RoutalPalette.neutral00} cx="12" cy="17.02" r="2.05" />
            <circle fill={RoutalPalette.neutral00} cx="17.81" cy="17.02" r="2.05" />
          </>
        ) : (
          <>
            <path
              fill={RoutalPalette.neutral60}
              d="m17.6,1.9h-.19v-.94c0-.41-.34-.75-.75-.75s-.75.34-.75.75v.94h-7.81v-.94c0-.41-.34-.75-.75-.75s-.75.34-.75.75v.94h-.19C3.25,1.9.69,4.46.69,7.61v10.1c0,3.15,2.56,5.72,5.72,5.72h11.19c3.15,0,5.72-2.56,5.72-5.72V7.61c0-3.15-2.56-5.72-5.72-5.72Zm4.22,15.82c0,2.32-1.89,4.22-4.22,4.22H6.4c-2.33,0-4.22-1.89-4.22-4.22V7.61c0-2.33,1.89-4.22,4.22-4.22h.19v.94c0,.41.34.75.75.75s.75-.34.75-.75v-.94h7.81v.94c0,.41.34.75.75.75s.75-.34.75-.75v-.94h.19c2.32,0,4.22,1.89,4.22,4.22v10.1Z"
            />
            <path
              fill={RoutalPalette.neutral60}
              d="m6.19,12.05c-1.13,0-2.05-.92-2.05-2.05s.92-2.05,2.05-2.05,2.05.92,2.05,2.05-.92,2.05-2.05,2.05Zm0-2.6c-.3,0-.55.25-.55.55s.25.55.55.55.55-.25.55-.55-.25-.55-.55-.55Z"
            />
            <path
              fill={RoutalPalette.neutral60}
              d="m17.81,12.05c-1.13,0-2.05-.92-2.05-2.05s.92-2.05,2.05-2.05,2.05.92,2.05,2.05-.92,2.05-2.05,2.05Zm0-2.6c-.3,0-.55.25-.55.55s.25.55.55.55.55-.25.55-.55-.25-.55-.55-.55Z"
            />
            <path
              fill={RoutalPalette.neutral60}
              d="m12,18.88c-1.13,0-2.05-.92-2.05-2.05s.92-2.05,2.05-2.05,2.05.92,2.05,2.05-.92,2.05-2.05,2.05Zm0-2.6c-.3,0-.55.25-.55.55s.25.55.55.55.55-.25.55-.55-.25-.55-.55-.55Z"
            />
            <path
              fill={RoutalPalette.neutral60}
              d="m17.81,18.88c-1.13,0-2.05-.92-2.05-2.05s.92-2.05,2.05-2.05,2.05.92,2.05,2.05-.92,2.05-2.05,2.05Zm0-2.6c-.3,0-.55.25-.55.55s.25.55.55.55.55-.25.55-.55-.25-.55-.55-.55Z"
            />
          </>
        )}
      </g>
    </SvgIcon>
  );
}
